export default {
  allSubOrgs: 'All sub-orgs',
  allLobs: 'All LoBs',
  selectAllSubOrgs: 'All (inc. future sub-orgs)',
  selectAllLobs: 'All (inc. future lobs)',
  lobsLabel: 'Lines of Business',
  atLeastOneSubOrg: 'Select at least one Sub-Organization',
  atLeastOneLob: 'Select at least one Line of Business',
} as const;
